import { Entry } from '../Entry'

export function Entry20250618() {
  return (
    <Entry title="2025 Jun 18 - v3.10.13">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17850/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
